
<template lang="pug">
q-page.flex

  .q-ma-xl(v-if="weathers")
    p: b 気象情報 (by 気象庁)
    table
      thead
        tr
          th 日付
          th 昼
          th 夜
      tbody
        tr(v-for="weather in weathers")
          td {{weather.date|date}}
          td {{weather.before}}
          td {{weather.after}}

  .q-ma-xl(v-if="holidays")
    p: b 祝日情報 (by google)
    table
      thead
        tr
          th 日付
          th 名称
      tbody
        tr(v-for="holiday in holidays")
          td {{holiday.date|date}}
          td {{holiday.label}}

</template>

<script>
import AxiosMixin from 'mixins/axios'

export default {
  mixins: [AxiosMixin],

  data() {
    return {
      weathers: null,
      holidays: null,
    }
  },

  mounted() {
    this.reload()
  },

  methods: {
    async reload() {
      try {
        const [
          {data: weathers},
          {data: holidays},
        ] = await Promise.all([
          this.axios.get('/api/weathers'),
          this.axios.get('/api/holidays'),
        ])

        this.weathers = weathers
        this.holidays = holidays
      }
      catch(e) {this.$handler(e)}
    },
  },
}
</script>

<style lang="sass">
</style>
